import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

/**
 * Réserve une page aux administrateurs réels de l'organisation.
 * Une permission générique « * » ne suffit pas : le rôle doit être présent
 * dans le JWT afin de rester cohérent avec la sécurité Symfony.
 */
export const adminRoleGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);

  return auth.hasAnyRole(['ROLE_ADMIN', 'ROLE_SUPER_ADMIN'])
    ? true
    : router.createUrlTree(['/tableau-de-bord']);
};
